import {
  AdminSpinner,
  ListSpinner,
  QueryStatus,
  restaurantImage,
} from '@vgrubs/components';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';
import { useVerificationsBrandsInfiniteScroll } from '../hooks/useVerificationsBrandsInfiniteScroll';
import { BrandVerificationComponent } from '../components/BrandVerificationComponent';

export const BrandsVerifications = ({ query }: { query: string }) => {
  const { brandsVerifications, observerRef, isFetchingNextPage, status } =
    useVerificationsBrandsInfiniteScroll(query);

  return (
    <>
      {brandsVerifications.map((brandVerification) => (
        <BrandVerificationComponent
          key={brandVerification.id}
          brandVerification={brandVerification}
        />
      ))}

      {brandsVerifications.length === 0 &&
        status !== QueryStatus.PENDING &&
        !isFetchingNextPage && (
          <NoDataComponent
            image={restaurantImage}
            title="No Brands!"
            description={
              query
                ? `No brands to verify match "${query}".`
                : 'You currently do not have any brands to verify.'
            }
            height="70vh"
            heightSM="70vh"
          />
        )}

      <ListSpinner loading={isFetchingNextPage} observerRef={observerRef} />
      {status === QueryStatus.PENDING && <AdminSpinner />}
    </>
  );
};
